import api from '../../api'
import { endpoints } from '../../apiCommons'
import localCompany from '../localStorage/localCompany'

const createNN = async ({
  sEmpresa,
  sCentroCosto,
  sSucursal,
  idGrupo,
  nCantCuentas,
}) => {
  const token = localStorage.getItem('token')
  return api.post(
    endpoints.create_nn_account,
    {
      sEmpresa,
      sCentroCosto,
      sSucursal,
      idGrupo,
      nCantCuentas,
    },
    { headers: { token } },
  )
}

const asignNN = async (data) => {
  const token = localStorage.getItem('token')
  return api.post(endpoints.asignNN, data, { headers: { token } })
}

const listNN = async ({
  nPagina,
  nEmpleadosPagina,
  sBusqueda = '',
  sEstado,
}) => {
  const token = localStorage.getItem('token')
  const { sEmpresa } = localCompany.getUserData()
  return api.get('ListadoCuentasNN', {
    params: {
      sEmpresa,
      nPagina,
      nEmpleadosPagina,
      sBusqueda: sBusqueda.trim(),
      sEstado,
    },
    headers: { token },
  })
}

const blockCard = async (data) => {
  const token = localStorage.getItem('token')
  return api.post('/ReposicionTarjeta', { Datos: data }, { headers: { token } })
}
const resetCard = async (data) => {
  const token = localStorage.getItem('token')
  return api.post('/ResetCuentaNN', { lCuentaNN: data }, { headers: { token } })
}

const multiDenyEnrolment = async (cuentasNN) => {
  const token = localStorage.getItem('token')
  return api.post(endpoints.denyEnrolment, cuentasNN, { headers: { token } })
}
const denyEnrollment = async (id) => {
  const token = localStorage.getItem('token')
  return api.post(endpoints.denyEnrolment, [{ id }], { headers: { token } })
}
const approveEnrollment = async (id) => {
  const token = localStorage.getItem('token')
  return api.post(endpoints.approveAssign, [{ id }], { headers: { token } })
}
const multiApproveEnrollment = async (ids) => {
  const token = localStorage.getItem('token')
  return api.post(endpoints.approveAssign, ids, { headers: { token } })
}

const multiDenyReasign = async (ids) => {
  const token = localStorage.getItem('token')
  return api.post(endpoints.denyReasign, ids, { headers: { token } })
}
const denyReasign = async (id) => {
  const token = localStorage.getItem('token')
  return api.post(endpoints.denyReasign, [{ id }], { headers: { token } })
}

const multiApproveReasign = async (ids) => {
  const token = localStorage.getItem('token')
  return api.post(endpoints.approveReasign, ids, { headers: { token } })
}

const approveReasign = async (id) => {
  const token = localStorage.getItem('token')
  return api.post(endpoints.approveReasign, [{ id }], { headers: { token } })
}

export default {
  createNN,
  asignNN,
  listNN,
  blockCard,
  resetCard,
  denyEnrollment,
  multiDenyEnrolment,
  approveEnrollment,
  multiApproveEnrollment,
  approveReasign,
  multiApproveReasign,
  denyReasign,
  multiDenyReasign,
}
